<div class="example-container mat-elevation-z2">
  <mat-table #table [dataSource]="dataSource">
    <ng-container cdkColumnDef="icon">
      <mat-header-cell *cdkHeaderCellDef>Icon</mat-header-cell>
      <mat-cell *cdkCellDef="let row"><i [class]="row.icon"></i> </mat-cell>
    </ng-container>
    <ng-container cdkColumnDef="name">
      <mat-header-cell *cdkHeaderCellDef>Name</mat-header-cell>
      <mat-cell *cdkCellDef="let row">{{ row.name }} </mat-cell>
    </ng-container>
    <ng-container cdkColumnDef="order">
      <mat-header-cell *cdkHeaderCellDef>Order</mat-header-cell>
      <mat-cell *cdkCellDef="let row">
        @if (ordinals.get(row.id)) {
          <input
            matInput
            [formControl]="ordinals.get(row.id)"
            />
        }
      </mat-cell>
    </ng-container>
    <ng-container cdkColumnDef="action">
      <mat-header-cell *cdkHeaderCellDef>Action</mat-header-cell>
      <mat-cell *cdkCellDef="let row">
        <button
          [disabled]="ordinals.get(row.id).disabled"
          ca-raised-button
          color="primary"
          (click)="save.emit({ row: row, ordinal: ordinals.get(row.id).value })"
          >
          Save
        </button>
        <button
          [disabled]="ordinals.get(row.id).disabled"
          ca-action-button
          color="warn"
          (click)="remove.emit(row)"
          >
          Remove
        </button>
      </mat-cell>
    </ng-container>
    <mat-header-row *cdkHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *cdkRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
</div>
